// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2TaBe","label":"LabeledBox_label__2lD4Z"};